import React from 'react'
import { Path, Svg } from 'react-native-svg'
import { IconProps } from '@tabler/icons-react-native'

export default function IconShOutlined({ size = 24, ...props }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M6 15C6 15.2652 6.10536 15.5196 6.29289 15.7071C6.48043 15.8946 6.73478 16 7 16H9C9.26522 16 9.51957 15.8946 9.70711 15.7071C9.89464 15.5196 10 15.2652 10 15V13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12H7C6.73478 12 6.48043 11.8946 6.29289 11.7071C6.10536 11.5196 6 11.2652 6 11V9C6 8.73478 6.10536 8.48043 6.29289 8.29289C6.48043 8.10536 6.73478 8 7 8H9C9.26522 8 9.51957 8.10536 9.70711 8.29289C9.89464 8.48043 10 8.73478 10 9"
        stroke={props.color}
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14 16V8M18 8V16M14 12H18"
        stroke={props.color}
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 5.77778C2 5.30628 2.23413 4.8541 2.65087 4.5207C3.06762 4.1873 3.63285 4 4.22222 4H19.7778C20.3671 4 20.9324 4.1873 21.3491 4.5207C21.7659 4.8541 22 5.30628 22 5.77778V18.2222C22 18.6937 21.7659 19.1459 21.3491 19.4793C20.9324 19.8127 20.3671 20 19.7778 20H4.22222C3.63285 20 3.06762 19.8127 2.65087 19.4793C2.23413 19.1459 2 18.6937 2 18.2222V5.77778Z"
        stroke={props.color}
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
